export default __webpack_public_path__ + "static/media/logo.fb6c24f7.png";